export const iconFontAwesomeEmojiFaceSadTear = (
	<i className="fa-solid fa-face-sad-tear"></i>
);
